import React from "react"
import Barcode from "react-barcode"
import { typography } from "theme"

// Simple reusable component, handles simple ui or functions
export const BarcodeComponent = (props) => {
  const { ...restProps } = props

  // --------------------RENDER
  return (
    <Barcode font={typography.primary.normal} fontSize={16} marginTop={10} {...restProps}></Barcode>
  )
}
